import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/auth';
import { containsDisallowedDomain, validateURL } from '../../lib/common';
import { useSessionStorage } from '../../hooks';
import { bannerTickerCreate, bannerUpdateHLink, handleImpressionsTrack } from '../../api';

function LinkWebsiteInput({ hLink, setHLinkResp, bannerData, setBannerData, projectId }) {
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const getBannerType = sessionStorage.getItem('bannerType');
  const [isValidURL, setIsValidURL] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [userDetails] = useSessionStorage('userDetails', '');

  useEffect(() => {
    setShowErr(false);
    const isValid = validateURL(
      getBannerType === 'Web Banner' ? bannerData?.hLink : bannerData?.mobileBannerRedirectUrl,
      getBannerType,
    );
    setIsValidURL(isValid);
  }, [bannerData?.hLink, bannerData?.mobileBannerRedirectUrl]);
  const handleSubmit = async () => {
    if (getBannerType === 'Web Banner') {
      try {
        if (!containsDisallowedDomain(bannerData?.hLink)) {
          const params = {
            docid: projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '',
            hlink: bannerData?.hLink || '',
          };
          const res = await bannerUpdateHLink(params);
          setHLinkResp(
            res && res?.errorCode === 0 ? res?.result || '' : res?.errorCode === 1 ? res?.message || '' : '',
          );
          setBannerData({ ...bannerData, hLink: '' });
        } else {
          setShowErr(true);
        }
      } catch (e) {
        console.log('error in bannerUpdateHLink', e);
      }
    } else {
      try {
        if (!containsDisallowedDomain(bannerData?.mobileBannerRedirectUrl)) {
          const commonParams = {
            id: 'mobileBannerTicketCreate',
            banner_path: bannerData?.mobileBannerImg || '',
            instruction: '',
            banner_cta: bannerData?.banner_cta || '',
            redirect_url: bannerData?.mobileBannerRedirectUrl || '',
            designBannerVertical: 'Design Banner',
            sourceNm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
            createdBy: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
            src: projectId === 'csportal' ? 'business' : 'sales-genio',
            srcType:
              projectId === 'genio'
                ? selectedBusinessGenio?.concern === 'client'
                  ? 'client'
                  : 'internal'
                : 'csportal',
            projectId: projectId === 'csportal' ? 1 : '',
            designSubIssue: 'Link with website',
            source: `hyperlinkbox_submitbutton_${projectId}`,
            issueComment: bannerData?.mobileBannerRedirectUrl || '',
          };
          let updtParams = {};
          if (projectId === 'csportal') {
            updtParams = {
              ...commonParams,
              dataCity: selectedBusiness?.data_city || '',
              docid: selectedBusiness?.docid || '',
              parentid: selectedBusiness?.parentid || '',
              companyname: selectedBusiness?.compname || '',
              fullName: userDetails?.fullName || '',
              mobile: userDetails?.mobile || '',
            };
          } else {
            updtParams = {
              ...commonParams,
              dataCity: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
              docid: selectedBusinessGenio?.docId || '',
              parentid: selectedBusinessGenio?.parentId || '',
              companyname: selectedBusinessGenio?.companyName
                ? encodeURIComponent(selectedBusinessGenio?.companyName)
                : '',
              fullName: profile?.full_name || '',
              mobile: profile?.mobile || '',
            };
          }

          const res = await bannerTickerCreate(updtParams);
          setHLinkResp(
            res && res?.errorCode === 0 ? res?.result || '' : res?.errorCode === 1 ? res?.message || '' : '',
          );
          setBannerData({ ...bannerData, mobileBannerRedirectUrl: '' });
        } else {
          setShowErr(true);
        }
        if (projectId === 'csportal') {
          const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
          const liVal = 'click';
          const liTrd = `cta_submit`;
          const faqTypeVal = '';
          const othersData = [];
          const llTrd = `issue_${bannerType}`;
          await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
        }
      } catch (e) {
        console.log('Error in jdrr ticket creation', e);
      }
    }
  };
  const handleUrlChange = (val) => {
    if (getBannerType === 'Web Banner') {
      setBannerData({ ...bannerData, hLink: val });
    } else {
      setBannerData({ ...bannerData, mobileBannerRedirectUrl: val });
    }
  };
  return (
    <>
      <div>
        <input
          value={getBannerType === 'Web Banner' ? bannerData?.hLink : bannerData?.mobileBannerRedirectUrl}
          onChange={(e) => handleUrlChange(e.target.value)}
          type="text"
          className="link-website-input"
        />
        {showErr && <span className="colorEC4 font12">Please avoid third party website addresses.</span>}
        {getBannerType === 'Mobile Banner' &&
          !isValidURL &&
          !(
            bannerData?.mobileBannerRedirectUrl.startsWith('http://') ||
            bannerData?.mobileBannerRedirectUrl.startsWith('https://')
          ) && <span className="colorEC4 font12">Website address should start with either http:// or https.//</span>}
        <div className="link-website-button-div">
          <button
            disabled={
              !isValidURL ||
              (getBannerType === 'Web Banner' && bannerData?.hLink === hLink) ||
              (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerRedirectUrl === hLink)
            }
            onClick={() => handleSubmit()}
            type="button"
            className={`${
              !isValidURL ||
              (getBannerType === 'Web Banner' && bannerData?.hLink === hLink) ||
              (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerRedirectUrl === hLink)
                ? 'link-website_button_disabled'
                : 'link-website_button'
            } font15 fw500 colorFFF mt-10`}
          >
            Submit
          </button>
        </div>
      </div>
      <div className="font12 clr777 mt-6">Note: Website address will be checked & verified by Moderator.</div>
      <div className="font12 clr777">Third party website addresses wont be allowed</div>
    </>
  );
}

export default LinkWebsiteInput;
LinkWebsiteInput.propTypes = {
  hLink: PropTypes.string,
  setHLinkResp: PropTypes.func,
  bannerData: PropTypes.object,
  setBannerData: PropTypes.func,
  projectId: PropTypes.string,
};
